export const pages = {
    home: {
        name: "表紙",
        url: "/",
        priority: 0,
    },
    us: {
        name: "私たち。",
        url: "/us",
        priority: 1,
    },
    world: {
        name: "世界",
        url: "/world",
        priority: 1,
    },
    politics: {
        name: "政治",
        url: "/politics",
        priority: 1,
    },
    business: {
        name: "仕事",
        url: "/business",
        priority: 1,
    },
    opinion: {
        name: "意見",
        url: "/opinion",
        priority: 2,
    },
    health: {
        name: "健康",
        url: "/health",
        priority: 2,
    },
};
